module.exports = __webpack_public_path__ + "img/dash-card-cancelled.1c595f47.svg";